// All routes come here
export const HOME = '/';
export const SEO_LANDING_PAGE_ROOT = '/stellenangebote';
export const SEO_LANDING_PAGE = `${SEO_LANDING_PAGE_ROOT}/[targetSlug]`;
export const JOB_BOARD = '/job-board';
export const JOB = '/job';
export const JOB_DETAILS = '/job-details';
export const JOBS = '/jobs';
export const FOR_EMPLOYERS = '/arbeitgeber';
export const BLOG = '/magazin';
export const BLOG_AUTHORS = '/magazin/autoren';
export const BLOG_ARTICLE = '/magazin/article';
export const DASHBOARD = '/dashboard';
export const APPLICATIONS = '/applications';
export const OFFERS = '/offers';
export const CHAT_ROOT = '/chat';
export const CHAT_CONVERSATION = '/chat/[[...slugs]]';
export const FAQS = '/faqs';
export const FUNNEL = '/funnel';
export const FUNNEL_COMPLETE = '/funnel/complete';
export const FILE = '/file';
export const LOGIN = '/login';
export const LOGIN_SMS = '/login/sms';
export const PROFILE = '/profile';
export const EDIT_PROFILE = '/profile/edit';
export const JOB_LINK = `/job`;
export const JOB_PREVIEW = `/job/[nameOfCity]/preview`;
export const SETTINGS = '/account-settings';
export const LOGOUT = '/logout';
export const CANDIDATE_CHAT = '/chat';
export const TERMS_AND_CONDITIONS = '/terms-and-conditions';
export const IMPRINT_AND_PRIVACY = '/imprint-privacy';
export const CONTACT = '/contact';
export const FAST_TRACK = '/fast-track';
export const GEHALT = '/gehalt';
export const SALARY_CALCULATOR = '/gehaltsrechner';
export const CONTINUING_EDUCATION_IN_NURSING = '/weiterbildungen-in-der-pflege';
// TODO: GREEN-GR: Some variables are also repeated on token-callbacks.ts. Maybe we can share them between both files to avoid duplication.
export const FORGOT_PASSWORD = '/forgot-password';
export const SET_PASSWORD = '/finish-registration';
export const CANDIDATE_SECOND_STEP_REGISTRATION = '/candidate/second-step-registration';
export const FUNNEL_PROMPT = '/funnel/prompt';
export const MAGIC_LINK = '/auth/magic/[token]';
export const SLIMMED_DOWN_FUNNEL_ROOT = '/funnel/job';
export const SLIMMED_DOWN_FUNNEL = `${SLIMMED_DOWN_FUNNEL_ROOT}/[jobId]`;
export const EXTERNAL_JOB_ROOT = '/external-job';
export const EXTERNAL_JOB = `${EXTERNAL_JOB_ROOT}/[slug]`;
export const JOB_BY_ID = (jobId: string) => `/job-by-id/${jobId}`;
export const CHAT_BY_JOB_POSITION_ID = (jobPositionId: string) => `/chat-by-job-position-id/${jobPositionId}`;
export const MAINTENANCE = '/maintenance';
export const UNSUBSCRIBE = '/unsubscribe';
export const WORK_AT_PFLEGIA = '/arbeiten-bei-pflegia';
export const UEBER_PFLEGIA = '/ueber-pflegia';
export const UEBER_PRAXIA = '/ueber-praxia';
export const PRESS = '/presse';
export const PRESS_RELEASES = '/presse-mitteilungen';
export const PRESS_PREVIEWS = '/pressespiegel';
export const EMPLOYERS = '/employers';
export const REGION = '/regionen';

export const INVALID_LINK_URL = `/invalid`;
export const INVALID_MAGIC_LINK_URL = `${HOME}?invalidMagicLink=true`;
export const PFLEGIA_FRIENDS_PROGRAM = '/freunde-programm';

// URLs for FAQ links
export const MAGAZIN_JOB_APPLICATION_TIPS_URL = `${BLOG}?utm_source=faq`;
export const SALARY_REPORT_MAGAZIN_ARTICLE_URL = `${BLOG_ARTICLE}/pflege-gehaltsreport-so-viel-verdienen-pflegekrafte-in-deutschland?utm_source=faq`;
export const CHANGING_CAREERS_MAGAZIN_ARTICLE_URL = `${BLOG_ARTICLE}/quereinstieg-in-die-pflege-dein-weg-zum-traumberuf?utm_source=faq`;

// URLs for Uber regions links
export const REGIONS_ANALYSIS_URL = `${BLOG_ARTICLE}/ost-west-gefalle-in-der-pflege-hamburg-hat-die-zufriedensten-pflegekrafte-thuringen-die-unzufriedensten?utm_source=regionen_landing_page`;
export const PFLEGIA_ANALYSIS_URL = `${BLOG_ARTICLE}/pflege-analyse-40-prozent-der-pflegekrafte-kommen-aus-dem-ausland?utm_source=regionen_landing_page`;
export const NURSING_HOMES_COMPARISON_URL = `${BLOG_ARTICLE}/pflegeheime-im-stadte-vergleich-chemnitz-mit-dem-besten-platzangebot-braunschweig-mit-den-niedrigsten-kosten?utm_source=regionen_landing_page`;
export const PARENTAL_SERVICES_URL = `${BLOG_ARTICLE}/pflege-analyse-elterndienste-vor-allem-von-frauen-gefragt?utm_source=regionen_landing_page`;
export const CARE_SHORTAGE_URL = `${BLOG_ARTICLE}/pflegemangel-in-deutschen-grossstadten-wo-der-bedarf-am-hochsten-ist?utm_source=regionen_landing_page`;
export const SALARY_REPORT_URL = `${BLOG_ARTICLE}/pflege-gehaltsreport-so-viel-verdienen-pflegekrafte-in-deutschland?utm_source=regionen_landing_page`;
export const OUTPATIENT_SERVICES_URL = `${BLOG_ARTICLE}/ambulanter-pflegedienst-als-pflegefachkraft-beim-ambulanten-pflegedienst-arbeiten?utm_source=regionen_landing_page`;

export const PROTECTED_ROUTES = [
  DASHBOARD,
  APPLICATIONS,
  OFFERS,
  CHAT_ROOT,
  PROFILE,
  EDIT_PROFILE,
  SETTINGS,
  FAST_TRACK,
  FUNNEL_PROMPT,
  CANDIDATE_SECOND_STEP_REGISTRATION,
  UNSUBSCRIBE,
];
export const PUBLIC_ONLY_ROUTES = [LOGIN, FORGOT_PASSWORD, SEO_LANDING_PAGE, SLIMMED_DOWN_FUNNEL, FUNNEL, FUNNEL_COMPLETE];
